// extracted by mini-css-extract-plugin
export var md = "_1k-4";
export var semantic = "_1k-5";
export var sm = "_1k-3";
export var text = "_1k-6";
export var toggleInput = "_1k-0";
export var toggleSwitch = "_1k-1";
export var xs = "_1k-2";